import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import "./fboModal.css";
import Button from "react-bootstrap/Button";
import { AiOutlineClose } from "react-icons/ai";
import Modal from "react-bootstrap/Modal";

const FBOModal = ({ localizedText, history }) => {
  const [showModal, setShowModal] = useState(true);

  const handleRedirectToBankVerification = () => {
    setShowModal(false);
    history.push("/dashboard/settings/bank-account-verification");
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      className="primary-modal fbo-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title>{localizedText["fbo-account-available"]}</Modal.Title>
        <AiOutlineClose className="close-button" onClick={handleCloseModal} />
      </Modal.Header>

      <Modal.Body style={{ "white-space": "pre-wrap" }}>
        <p>
          {
            localizedText[
              "a-for-benefit-of-account-separates-your-money-from-the-financial-institutions-operational-funds"
            ]
          }
        </p>
        <p>
          {
            localizedText[
              "as-a-us-based-user-you-are-eligible-to-open-an-FBO-account"
            ]
          }
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button className="outside-secondary-button" onClick={handleCloseModal}>
          {localizedText["close"]}
        </Button>
        <Button
          className="outside-primary-button"
          onClick={handleRedirectToBankVerification}
        >
          {localizedText["open-fbo-account"]}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default withRouter(FBOModal);
